import { useMemo, Fragment } from 'react';
import '/assets/styles/sections/home-product-banners.scss';

// Partials
import Slider from '/views/partials/slider';
import Placeholder from '/views/partials/placeholder';
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Link from '@wearetla/tla-essentials-tools/partials/link';

const HomeProductBanners = ({ data }) => {
	const slides = useMemo(() => {
		return data ?? [false, false];
	}, [data]);

	return (
		<section className="section home-product-banners">
			<div className="wrapper banners-wrap">
				<Slider
					params={{
						loopAdditionalSlides: 1,
					}}
					className="banners-slider"
				>
					{slides.map((slide, nth) => (
						<Fragment key={slide.id ?? nth}>
							<div className="slider-slide" key={slide.id ?? nth}>
								{slide ? (
									<Link raw className="slider-item" href={slide.link}>
										<Img
											lazy={nth > 1}
											cover
											className="item-image"
											src={slide.path}
											alt={slide.title ?? 'Banner'}
										/>
									</Link>
								) : (
									<div className="slider-item">
										<Placeholder primary className="item-image" />
									</div>
								)}
							</div>
						</Fragment>
					))}
				</Slider>
			</div>
		</section>
	);
};

export default HomeProductBanners;
